module.exports = __webpack_public_path__ + "stu-res/img/gv-oedu@3x.17040b13.png";